export default {
  build: 'mq-234f130',
  builtAt: '1793774748',
};
